import { endOfDay } from 'date-fns'

export default function dueDateTimestamp(dueDate: Date) {
  return endOfDay(dueDate)
}
